import * as React from "react";
import { forwardRef } from "react";
const SvgInprocess = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 34, height: 34, viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 17, cy: 17, r: 17, fill: "#1976D2" }), /* @__PURE__ */ React.createElement("path", { d: "M16 7V17L24 23", stroke: "white", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgInprocess);
export { ForwardRef as ReactComponent };
